export default __webpack_public_path__ + "static/media/DesktopGifItem1.1d4c36c5.gif";